namespace HA.Core.HTML {
    export class MenuPane extends HA.Core.HTML.Box {
        public clear(): this {
            this.getItems().clear();
            return this;
        }

        public addItem(data: Map<string, any>): void {
            data.set("click", () => {
                this.handleClick(data);
            });
            this.getItems().addItem(new MenuItem(data));
        }

        public handleClick(data: any) {
            const a = data.get("a");
            const service: HA.Core.Service.App = getAppService();
            if (a instanceof Map || a instanceof Array) {
                service.processAction(toMap(a));
                return;
            }
            service.processAction(toMap({id: data.get("id"), t: "reloadApp"}));
        }

        protected createSelf(): void {
            super.createSelf();
            this.addClass("menupane");
            const items = new List({tag: new CFlexContainer({class : "menus"})});
            this.appendChild(items);
            this.addToData("items", items);
        }

        protected createItems(): void {
            const items: Map<any, any> = this.get("i");
            const me = this;
            if (items) {
                items.forEach((i) => {
                    me.addItem(toMap(i));
                });
            }
        }

        protected initialize(data: any): void {
            super.initialize(data);
            this.createItems();
        }

        private getItems(): List {
            return this.get("items");
        }
    }
}
